import styled from 'styled-components';

import tickets from '@assets/images/promotions/tickets.webp';
import bg from '@assets/images/promotions/tickets_background.webp';

export const Wrapper = styled.div`
	padding: 24px;
	position: relative;
	overflow: hidden;
	border-radius: 16px;

	background-image: linear-gradient(0deg, #000f8a 0%, rgba(30, 55, 178, 0) 100%), url('${bg}');
	background-position: right;
	background-size: contain;
	background-repeat: no-repeat;

	&::after {
		position: absolute;
		content: '';
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;

		background-image: url('${tickets}');
		background-position: right bottom;
		background-size: 300px;
		background-repeat: no-repeat;

		@media (max-width: 992px) {
			background-size: 150px;
		}
	}

	@media (max-width: 992px) {
		padding: 16px;
	}
`;

export const Content = styled.div`
	position: relative;
	z-index: 20;
`;

export const Title = styled.h3`
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	margin-bottom: 24px;

	@media (max-width: 992px) {
		font-size: 24px;
		line-height: 33px;
		margin-bottom: 16px;
	}
`;

export const CountRow = styled.div`
	display: flex;
	gap: 8px;
	margin-bottom: 24px;

	@media (max-width: 992px) {
		margin-bottom: 16px;
	}
`;

export const CountText = styled.p`
	font-size: 24px;
	line-height: 33px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};

	margin: 0;

	@media (max-width: 992px) {
		font-size: 20px;
		line-height: 27px;
	}
`;

export const CountNumber = styled.div`
	font-size: 24px;
	line-height: 33px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	display: flex;
	gap: 4px;

	margin: 0;

	@media (max-width: 992px) {
		font-size: 20px;
		line-height: 27px;
	}
`;

export const TicketIconWrapper = styled.div`
	display: flex;
	align-items: center;
	svg {
		path {
			fill: ${({ theme }) => theme.colors.icon.chevron};
		}
	}
`;
